module.exports = Promise.all([__parcel__import__("hsljJ"), __parcel__import__("hNmbh")]).then(() => parcelRequire('3pHq1'));